<template>
    <section id="page-container-red">
        <Navbar/>
        <spinner v-if="isLoading" :color="'text-light'" />
        <div class="container-fluid calltoaction" v-if="!isLoading">
            <p class="text-white text-center py-4" style="font-size:1.3em"><strong>Do you have Ideas for how to make AfCFTA work better? Share them here and secure investment!</strong></p><section class="row">
                <div class="col-md-9 text-center">
                    <div class="col-12">
                        <div class="card">
                        <div class="card-header">
                            <h2>Instructions</h2>
                        </div>
                        <div class="card-body">
                            <p>
                                The AfCFTA Secretariat,  the Sankoree Institute of AfroChampions and the AU 
                                Open Corridors Initiative invite entrepreneurs and innovators to apply to the 
                                AfCFTA Vision Challenge bearing in mind three deadlines: Fast Round: November 27th Last Round: January 21st 2021
                            </p>
                            <p>
                                <strong>The Prize:</strong> Potential Investment in your idea by Africa's leading Development Finance Institutions & Banks
                                 (such as AfDB, TDB, Afreximbank, BADEA, AFC, Equity Bank, Ecobank, CIB & more).
                            </p>
                            <p>
                                 <strong>Instructions: </strong> study the visions shared below
                                 by Africa's Political Leaders and the nuances and caveats raised by its leading thinkers,
                                 pause, and dazzle our jury of institutional investors with a 5-page plan that shows why 
                                 you/your team are best placed to realise the leaders' visions in the 8 critical issue areas
                                 based on Agenda 2063. 
                            </p>
                            <p>
                                Choose your own format for the plan but touch on product/solution, people/team, process/operations,
                                 innovation, social impact and financial sustainability.
                            </p>
                            <p>
                                <strong>upload it in both .docx and .pdf formats. Stand by to hear from us! </strong>
                            </p>
                        </div>
                    </div>
                    </div>
                    <!-- End of instructions -->
                    <div class="text-center pb-2">
                        <button @click="verifyUser" type="button" 
                        class="btn btn-warning text-light btn-lg my-4" data-toggle="modal"
                         data-target="#exampleModalCenter">
                            Upload new Leader's Vision
                         </button>
                  </div>
                <div class="col-xs-12 col-sm-12 py-3"
                    v-for="(challenge,key) in leadersVisions" :key="key">
                    <ChallengeCard :challengeKey="key" :challenge="challenge"/>
                </div>
                </div>
                <div class="col-md-3">
                    <DebateSidebar/>
                </div>
            </section>
        </div>
        <FinalFooter />
    </section>
</template>

<script>
/* allow-no-unused-vars */
import Spinner from '@/components/Spinner'
import FinalFooter from '../FinalFooter'
import Navbar from '../appBar'
import toasterMixin from '../../mixins/toasterMinxin'
import ChallengeCard from './ChallengeCard'
import DebateSidebar from '../debateSidebar'
import url from '../../helpers/url'
import service from '../../helpers/service'

    export default {
        components:{
            Navbar,
            ChallengeCard,
            DebateSidebar,
            FinalFooter,
            Spinner, 
           
        },
    data() {
        return {
            title:null,
            description:null,
            isLoading:false
        }
    },
    methods:{
        verifyUser() {
           
            const user = this.$session.get('entity')
                 if(!user) {
                    window.location.replace(`/redirect?service=login`)
                }
            
                this.$router.replace({ path:'/challenge/add_leaders_vision'})
        }
    },
    computed: {
        leadersVisions() {
            return this.$store.getters.leadersVisions
        }
    },
    mounted() {
        this.isLoading = true
        // document.querySelector('body').setAttribute('style', 'background-color:#ba2428')
        this.$store.dispatch('fetchLeadersVision').then(responnse => {
            if(responnse) {
                this.isLoading = false
            }
        } ).catch(err => {
            this.isLoading = false
        })
        
    },
    // beforeDestroy() {
    //     document.querySelector('body').removeAttribute('style')
    // },
    }
</script>

<style >
.calltoaction{
    padding-top: 150px;
}
.card-user {
  position: absolute;
  right: 10px;
  top: 10px;
}
.card-category {
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 20px;
}



</style>